import { type UseQueryResult, useQuery } from 'react-query';
import { PerformanceRuleService } from '../../services/wealthlane-award-services';

const useGetPerformanceRuleAvailableStatus = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string | number;
    }>
  | undefined,
  unknown
> => {
  const PerformanceRuleAvailableStatus = useQuery(
    ['getPerformanceRuleAvailableStatus'],
    async () => {
      return await handleRequest(
        PerformanceRuleService.getApiAwardApiAppPerformanceRuleRuleAvailableStatusList()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.name ?? '',
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return PerformanceRuleAvailableStatus;
};

export default useGetPerformanceRuleAvailableStatus;
